<template>

    <div class="filter-date-container">

        <button @click.prevent="clickFilter" :class="['btn', 'w-100', 'btn-filter', {active: open}]">
            {{ display }}
        </button>

        <filter-dialog v-if="open" :name="name" :size="sizeClass" :align="align">

            <div class="filter-content filter-date">

                <table id="date-selector" class="table">

                    <thead class="thead-dark">
                        <tr>
                            <th>Su</th>
                            <th>Mo</th>
                            <th>Tu</th>
                            <th>We</th>
                            <th>Th</th>
                            <th>Fr</th>
                            <th>Sa</th>
                        </tr>
                    </thead>

                    <tbody>
                    <tr v-for="week in weeks" :key="week[0].toISOString()">
                        <td v-for="day in week"
                            :key="day.toISOString()"
                            :class="{
                                today: day.isSame(momentNow, 'day'),
                                past: day.isBefore(momentNow, 'day'),
                                selected: day.isSame(momentSelected, 'day')}"
                        >
                            <a href="#" @click.prevent.stop="$emit('apply', day)">

                                <span class="tiny">{{ day.format('MMM').toUpperCase() }}</span>
                                {{ day.date() }}


                            </a>
                        </td>
                    </tr>
                    </tbody>

                </table>

            </div>

            <div class="text-center mt-1">
                <a class="btn btn-sm btn-secondary" @click.prevent="$emit('apply', '')" href="#">Clear {{ label }}</a>
            </div>

        </filter-dialog>
    </div>

</template>

<script>

import FilterMixin from '@/mls-filter/mixins/FilterMixin.js';
import moment from 'moment';
import { startCase } from 'lodash';

export default {

    mixins: [FilterMixin],

    props: {
        now: String,
        selected: String,
        // earliest: moment.Moment,
        // we don't need to track earliest unless we want to render an indicator showing
        // which day is the earliest selectable.
    },

    data() {

        // generates a week around a given day
        const generateWeekAround = (d) => {
            const sunday = moment(d).day(0);
            return [...Array(7).keys()].map((x) => moment(sunday).add(x, 'days'));
        };

        return {
            weeks: [
                generateWeekAround(this.momentNow),
                generateWeekAround(moment(this.momentNow).add(1, 'week')),
                generateWeekAround(moment(this.momentNow).add(2, 'week')),
                generateWeekAround(moment(this.momentNow).add(3, 'week')),
            ],
        };
    },

    // created() {
    //     console.log(this.now);
    // },

    computed: {

        sizeClass() {
            return 'medium';
        },

        momentSelected() {
            return moment(this.selected, 'YYYY-MM-DD');
        },

        momentNow() {
            return moment(this.now, 'YYYY-MM-DD');
        },

        selectedOption() {
            return new Error('Can\'t use selectedOption in filter-date.');
        },

        /* Label for single select filter */
        display() {
            if (this.selected) {
                return this.momentSelected.format('MMM D');
            } else {
                return startCase(this.name);
            }
        },
    },

    methods: {
        apply(filter, date) {
            throw new Error('Can\'t apply');
        },
    },
};

</script>


<style lang="scss" scoped>

    @import "@/common/scss/_variables.scss";

    table {

        background-color: $gray-100;
        border-bottom: 1px solid $gray-400;
        margin: 0;

        td, th {
            text-align: center;
        }

        td {
            padding: 0;
            transition: background 0.25s ease-out;


            a {
                padding: 7px 5px;
                text-decoration: none;
                display: block;

                .tiny {
                    font-size: 10px;
                    display: block;
                }

            }

            &.past {
                a {
                    color: #BBB !important;
                    pointer-events: none;
                    cursor: pointer;
                }
            }
            &.today {
                a { font-weight: bold; }
            }
            &.selected {
                transition: background 0.25s ease-in;
                background: $primary;
                a { color: white; }
            }
        }
    }

</style>
